exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.trainingWheels[data-v-47ec2642] {\n  border-style: solid;\n}\n.community-cal-container[data-v-47ec2642] {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-pack: center;\n          justify-content: center;\n}\n", ""]);

// exports
